module.exports = __webpack_public_path__ + "media/images/spinner_lj_2025-d4f1f7a5a5b79157dc8412b8b67ec424.svg";